import request from '@/utils/request'
const BASE_URL = '/GoodsType'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  getStoreTypes() {
    return request({
      url: BASE_URL + '/GetStoreTypes',
      method: 'post',
     
    })
  },
  oneSave() {
    return request({
      url: BASE_URL + '/OneSave',
      method: 'post',
    
    })
  },
  moreSave(data) {
    return request({
      url: BASE_URL + '/MoreSave',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getMaxOrderId(pid) {
    return request({
      url: BASE_URL + '/GetMaxOrderId',
      method: 'get',
      params: { pid }
    })
  },
}